import { z } from 'zod';

import { comboboxSchema } from '~/components/Combobox';

// Digital release notifications schema
const digitalReleaseNotificationsSchema = z.object({
  // Creation and upload
  importDraftUploaded: z.boolean(),
  failureDmdCreation: z.boolean(),
  failureGcdmCreation: z.boolean(),

  // Submission and packaging
  releaseSubmitted: z.boolean(),
  releaseRetracted: z.boolean(),
  releaseDbom: z.boolean(),

  // Editing and cancellation
  userRequestedCancelation: z.boolean(),
  releaseRequestedEditing: z.boolean(),

  // Rejection and removal
  userRequestedTakedown: z.boolean(),
  releaseTakenDown: z.boolean(),
  releaseRejected: z.boolean(),

  // Approval
  releaseApprovedByAda: z.boolean(),
  releaseApproved: z.boolean(),

  // Claiming
  releaseClaimed: z.boolean(),
  releaseClaimingFailed: z.boolean(),
});

// Main profile form schema
export const myProfileFormSchema = z.object({
  // Basic information
  phoneNumber: z.string(),
  language: comboboxSchema,
  dateFormat: z.string(),

  // Notifications
  digitalReleaseNotifications: digitalReleaseNotificationsSchema,
});

export type MyProfileFormSchema = z.infer<typeof myProfileFormSchema>;
